import React,{useContext,useState} from 'react'
import AuthContext from '../../context/AuthContext.js'
import {Modal,Button} from 'react-bootstrap'
import {IconContext} from "react-icons"
import { AiFillEdit } from "react-icons/ai";
import { RiDeleteBin5Fill } from "react-icons/ri";
import PrefixContext from "../../context/PrefixContext.js";
import {useHistory} from 'react-router-dom'
import axios from 'axios'
import Loading from '../Loading/index.js'
import EmptyList from '../EmptyList/index.js'

function Index(props) {
    
    const AuthContextData = useContext(AuthContext);
    const [showModal, setshowModal] = useState(false);
    const handleClose = () => setshowModal(false);
    const handleShow = () => setshowModal(true);
    const [loading, setloading] = useState('WAITING')

    const PrefixContextData = useContext(PrefixContext);
    const LoadingImage = PrefixContextData.cdnPrefixUrl+'roll-white2_fqgBRCMoUr.gif';
    let history = useHistory();
    const resumeCardStyle = {
        margin:'20px',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${LoadingImage})`,
        backgroundPosition:'center',
        backgroundSize:'cover',
        position:'relative',
        userSelect: 'none',
        MozUserSelect: 'none',
        KhtmlUserSelect: 'none',
        WebkitUserSelect: 'none',
        OUserSelect: 'none'
    }

    const handleConfirmedDeletionReq = (handlerId) => {
        setloading('LOADING');
        let token = localStorage.getItem('auth-token');
        axios.defaults.headers.common['Authorization'] = token;
        axios.get(PrefixContextData.prefixUrl+'data/resume/'+handlerId+'/delete')
            .then(response => {
                if(response.status === 200){
                    setloading('DELETED');
                }
                else{
                    setloading('FAILED');
                    console.log('Resume Deletion Failed')
                }
            })
            .catch(error => {
                if(error.response!==undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                }
                setloading('FAILED');
                console.log('Resume Deletion Failed')
            });
    }

    return (
        <>
        {loading === 'LOADING' && 
            <div className="resumeContainer d-flex justify-content-center flex-column bg-white mt-4" style={{width:'345px',height:'375px',contain:'strict',position:'relative'}}>
                <Loading type="withImage" size="small" label="Deleting"/>
            </div>
        }
        {loading === 'FAILED' &&
            <div className="resumeContainer bg-white mt-4" style={{width:'345px',height:'375px',contain:'strict',position:'relative'}}>
                <EmptyList label="Deletion failed please refresh page" />
            </div>
        }
        {loading === 'WAITING' &&
        <>
            <div style={resumeCardStyle}>
                <div className="resumeContainer" style={{width:'345px',height:'375px',contain:'strict',position:'relative'}}>
                    {props.children}
                </div>
                <div style={{position:'absolute',top:'-10px',right:'20px'}}>
                    <div className="edit-icon d-inline-block" onClick={()=>{history.push('resume/' + props.handlerId)}}>
                        <IconContext.Provider value={{className:"text-white"}}>
                            <AiFillEdit/>
                        </IconContext.Provider>
                    </div>
                    <div className="delete-icon d-inline-block" onClick={handleShow}>
                        <IconContext.Provider value={{className:"text-white"}}>
                            <RiDeleteBin5Fill/>
                        </IconContext.Provider>
                    </div>
                </div>
            </div>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header className="border-0">
                <Modal.Title>Delete Resume</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete the selected Resume?</Modal.Body>
                <div className="d-flex p-3 justify-content-between">
                    <Button variant='white' className="border border-black" onClick={handleClose}>
                        <p className="text-secondary mb-0">Cancel</p>
                    </Button>
                    <Button onClick={()=>{handleConfirmedDeletionReq(props.handlerId)}}>
                        <p className="mb-0">Confirm</p>
                    </Button>
                </div>
            </Modal>  
        </>
        }
        </>
    )
}

export default Index
